"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _textfield = _interopRequireDefault(require("britive-design-system/core/components/textfield"));

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _tooltip = _interopRequireDefault(require("britive-design-system/core/components/tooltip"));

var _table = _interopRequireDefault(require("britive-design-system/core/components/table"));

var _CopyButton = _interopRequireDefault(require("../../../../../components/copyButton/CopyButton"));

var _actions = require("../../../../../components/policy/notificationMedium/actions");

var _deleteIcon = _interopRequireDefault(require("../../../../../assets/delete-icon.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var styles = {
  channelsContainer: {
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
    alignItems: 'baseline'
  },
  channelNamesContainer: {
    display: 'flex',
    alignItems: 'end',
    gap: '10px'
  }
};

var ChannelNamesIdsList = function ChannelNamesIdsList(_ref) {
  var _IDsData$data, _IDsData$data$channel, _IDsData$data2, _IDsData$data2$channe;

  var notificationMedium = _ref.notificationMedium,
      isFromAllSecrets = _ref.isFromAllSecrets,
      setNotificationMedium = _ref.setNotificationMedium,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return isFromAllSecrets ? state === null || state === void 0 ? void 0 : state.secretsReducer : state === null || state === void 0 ? void 0 : state.policyReducer;
  }),
      _useSelector$Channels = _useSelector.ChannelsIDsReducer,
      ChannelsIDsReducer = _useSelector$Channels === void 0 ? {} : _useSelector$Channels;

  var IDsData = ChannelsIDsReducer.data;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      slackAppChannelsNames = _useState2[0],
      setSlackAppChannelsNames = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      slackAppChannelsList = _useState4[0],
      setSlackAppChannelsList = _useState4[1];

  (0, _react.useEffect)(function () {
    if (IDsData !== null && IDsData !== void 0 && IDsData.data) {
      var mappedArray = Object.entries((IDsData === null || IDsData === void 0 ? void 0 : IDsData.data) || {}).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
            key = _ref3[0];

        return key !== 'channels_not_found';
      }).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            channelName = _ref5[0],
            id = _ref5[1];

        return {
          channelName: channelName,
          id: id
        };
      });
      setSlackAppChannelsList(mappedArray);
      var newIDs = mappedArray === null || mappedArray === void 0 ? void 0 : mappedArray.map(function (item) {
        return item === null || item === void 0 ? void 0 : item.id;
      });
      var mergedIDs = [].concat(_toConsumableArray((notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.channels) || []), _toConsumableArray(newIDs)).filter(function (id, index, self) {
        return id && self.indexOf(id) === index;
      });
      setNotificationMedium(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          channels: mergedIDs
        });
      });
    }
  }, [IDsData]);
  var slackAppColumns = [{
    field: 'channelName',
    headerName: 'Channel Name',
    width: '180px'
  }, {
    headerName: 'Channel ID',
    width: '180px',
    renderColumn: function renderColumn(row) {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: styles.channelNamesContainer
      }, row === null || row === void 0 ? void 0 : row.id, /*#__PURE__*/_react.default.createElement(_CopyButton.default, {
        textToCopy: row === null || row === void 0 ? void 0 : row.id
      }));
    }
  }, {
    headerName: 'Action',
    renderColumn: function renderColumn(row, value, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-cell"
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: "Delete",
        position: "top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "action-button",
        onClick: function onClick() {
          setSlackAppChannelsList(function (prevList) {
            var updatedList = _toConsumableArray(prevList);

            var deletedChannel = updatedList.splice(index, 1)[0];

            if (deletedChannel !== null && deletedChannel !== void 0 && deletedChannel.id) {
              setNotificationMedium(function (prev) {
                var updatedChannels = prev.channels.filter(function (id) {
                  return id !== deletedChannel.id;
                });
                return _objectSpread(_objectSpread({}, prev), {}, {
                  channels: updatedChannels
                });
              });
            }

            return updatedList;
          });
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _deleteIcon.default,
        alt: "Delete"
      }))));
    }
  }];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.channelsContainer
  }, /*#__PURE__*/_react.default.createElement(_textfield.default, {
    label: "Channel Names",
    type: "text",
    helperText: 'Comma separated list of channel names',
    value: (slackAppChannelsNames === null || slackAppChannelsNames === void 0 ? void 0 : slackAppChannelsNames.join(',')) || '',
    width: "548px",
    onChange: function onChange(e) {
      var channels = e.target.value.length ? e.target.value.split(',').map(function (channel) {
        return channel.trim();
      }) : [];
      setSlackAppChannelsNames(channels);
    },
    disabled: disabled,
    error: (IDsData === null || IDsData === void 0 ? void 0 : (_IDsData$data = IDsData.data) === null || _IDsData$data === void 0 ? void 0 : (_IDsData$data$channel = _IDsData$data.channels_not_found) === null || _IDsData$data$channel === void 0 ? void 0 : _IDsData$data$channel.length) > 0,
    errorMsg: "Channels Not Found: ".concat(IDsData === null || IDsData === void 0 ? void 0 : (_IDsData$data2 = IDsData.data) === null || _IDsData$data2 === void 0 ? void 0 : (_IDsData$data2$channe = _IDsData$data2.channels_not_found) === null || _IDsData$data2$channe === void 0 ? void 0 : _IDsData$data2$channe.join(', '))
  }), /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: "secondary",
    onClick: function onClick() {
      return dispatch((0, _actions.getIDs)(notificationMedium.id, slackAppChannelsNames));
    }
  }, "Get ID(s)")), (slackAppChannelsList === null || slackAppChannelsList === void 0 ? void 0 : slackAppChannelsList.length) > 0 && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_table.default, {
    resizableColumns: true,
    columns: slackAppColumns || [],
    rows: slackAppChannelsList || []
  })));
};

ChannelNamesIdsList.propTypes = {
  isFromAllSecrets: _propTypes.default.bool,
  notificationMedium: _propTypes.default.object,
  setNotificationMedium: _propTypes.default.func,
  disabled: _propTypes.default.bool
};
var _default = ChannelNamesIdsList;
exports.default = _default;